<template>
    <ldc-dialog
        :title="title"
        :colorTitle="colorTitle"
        :clickoutside="true"
        width="50%"
        :fullscreen="$detect == 'mobile'"
        :class="{
            'product-dialog' : true,
            'modal-register-vip': $detect == 'web',
            'modal-mobile-vip position-relative': $detect == 'mobile',
            'modal-HappyLink' : action == 'add',
            'modal-dght' : action == 'edit',
            'modal-normal' : action == 'auto',
        }"
        :visible.sync="dialog">
        <div class="content-modal py-3 px-10px" v-if="action == 'edit'">
            <div class="d-flex">
                <div :class="{
                            'w-40' : true,
                            'fw-600' :  $detect == 'mobile'
                        }">
                    <div class="name">
                        Tên danh mục (trong Vatgia.com)
                    </div>
                </div>
                <div class="w-60">
                    <div class="value">
                        <a :href="$linkUrl(data.link)" class="text-decoration-none link-news"
                            v-if="!multiple" target="_blank">
                            {{arrEdit.cat_name}}
                           
                        </a>
                        <p class="mb-0 fw-600 text-primary link-news" v-else>
                            <span v-for="(item, index) in dataMultiple" :key="index">#{{item}}, </span>
                        </p>
                    </div>
                </div>
            </div>
            <div class="d-flex mt-3">
                <div :class="{
                            'w-40' : true,
                            'fw-600' :  $detect == 'mobile'
                        }">
                    <div class="name">
                        Tên danh mục (trong gian hàng)
                    </div>
                </div>
                <div class="w-60">
                    <div class="value">
                         <input :class="{
                                'm_input' : true,
                                'border-primary' : uc_cat_name_alias != ''
                            }" type="text" id="inputTitle"
                             v-model="uc_cat_name_alias" />
                    </div>
                </div>
            </div>
            <div class="d-flex mt-3">
                <div :class="{
                                'w-40' : true,
                                'd-flex fw-600' : $detect == 'mobile'
                            }">
                    <div class="name">Thuộc nhóm:</div>
                </div>
                <div class="w-60">
                    <div class="value">
                         <ldc-select
                            v-model="uc_group_id"
                            placeholder="Nhóm danh mục"
                            class="rv-select-form" v-if="$detect == 'web'">
                            <ldc-option 
                                v-for="(index, key) in arrGroup" :key="key"
                                :value="index.ucg_id"
                                :label="index.ucg_name"/>
                        </ldc-select>
                        <ldc-select-mobile
                            :showPlaceholder="false"
                            placeholder="Nhóm danh mục"
                            title="Nhóm danh mục"
                            v-model="uc_group_id"
                            class="select-mobile-post"
                            v-else>
                            <ldc-option-mobile
                                v-for="(index, key) in arrGroup" :key="key"
                                :value="index.ucg_id"
                                :label="index.ucg_name"/>
                        </ldc-select-mobile>
                    </div>
                </div>
            </div>
            <div class="d-flex mt-3">
                <div :class="{
                            'w-40' : true,
                            'd-flex fw-600' : $detect == 'mobile'
                        }">
                    <div class="name">Icon trang chủ:</div>
                </div>
                <div class="w-60">
                    <div class="value">
                        <div class="btn-img text-center w-100px float-left" role="button" @click="upload()">
                            <p class="mb-0"><i class="icon ion-md-cloud-upload"></i></p>
                            <p class="mb-0 fs-14px">Thêm ảnh</p>
                        </div>
                        <div class="image-icon float-left">
                            <img :src="picture" alt="" class="mw-100 mh-100">
                        </div>
                       <input type="file" v-show="false" name="" class="input-upload" placeholder="" @change="changeImage">
                    </div>
                </div>
            </div>
            <div class="d-flex mt-3">
                <div :class="{
                            'w-40' : true,
                            'fw-600' :  $detect == 'mobile'
                        }">
                    <div class="name">Thứ tự:</div>
                </div>
                <div class="w-60">
                    <div class="value">
                       <input type="text" class="m_input mr-1 text-right"
                            v-model="uc_order" ref="input-action-dialog" @input="maxAmount()"
                            @focus="(e) => e.target.select()"/>
                    </div>
                </div>
            </div>
             <div class="d-flex mt-3">
                <div :class="{
                            'w-40' : true,
                            'fw-600' :  $detect == 'mobile'
                        }">
                    <div class="name">Tùy chọn:</div>
                </div>
                <div class="w-60">
                    <input type="checkbox" id="homepage"  class="mr-1" name="homepage" value="homepage" v-model="checkedNames">
                    <label for="homepage">Hiển thị trang chủ</label><br>
                    <input type="checkbox" id="homepage_icon"  class="mr-1" value="homepage_icon" v-model="checkedNames">
                    <label for="homepage_icon">Hiển thị icon trang chủ</label><br>
                    <input type="checkbox" id="show_child" class="mr-1"  value="show_child" v-model="checkedNames">
                    <label for="show_child">Hiển thị cấp con</label><br>
                    <input type="checkbox" id="hide" class="mr-1"  value="hide" v-model="checkedNames">
                    <label for="hide">{{$detect == 'mobile' ? 'Không HT trên menu trái' : 'Không hiển thị trên menu trái'}}</label><br>
                </div>
            </div>
        </div>
        <div class="content-modal py-3 px-10px" v-if="action == 'add'">
            <div class="d-flex" v-if="$detect == 'web'">
                <div :class="{
                            'w-40' : true,
                            'fw-600' :  $detect == 'mobile'
                        }">
                    <div class="name">
                        Chọn nhóm danh mục sản phẩm:
                    </div>
                </div>
                <div class="w-60">
                     <div class="value">
                        <ldc-select
                            v-model="cat_parent"
                            placeholder="Nhóm danh mục"
                            class="rv-select-form" v-if="$detect == 'web'">
                            <ldc-option 
                                v-for="(index, key) in arrGroup" :key="key"
                                :value="index.ucg_id"
                                :label="index.ucg_name"/>
                        </ldc-select>
                        <ldc-select-mobile
                            :showPlaceholder="false"
                            placeholder="Nhóm danh mục"
                            title="Nhóm danh mục"
                            v-model="cat_parent"
                            class="select-mobile-post"
                            v-else>
                            <ldc-option-mobile
                                v-for="(index, key) in arrGroup" :key="key"
                                :value="index.ucg_id"
                                :label="index.ucg_name"/>
                        </ldc-select-mobile>
                    </div>
                </div>
            </div>
            <div class="d-flex" v-if="$detect == 'mobile'">
                <div class="w-100">
                    <div :class="{
                                'w-100' : true,
                                'fw-600' :  $detect == 'mobile'
                            }">
                        <div class="name">
                            Chọn nhóm danh mục sản phẩm:
                        </div>
                    </div>
                    <div class="w-100">
                         <div class="value">
                            <ldc-select
                                v-model="cat_parent"
                                placeholder="Nhóm danh mục"
                                class="rv-select-form" v-if="$detect == 'web'">
                                <ldc-option 
                                    v-for="(index, key) in arrGroup" :key="key"
                                    :value="index.ucg_id"
                                    :label="index.ucg_name"/>
                            </ldc-select>
                            <ldc-select-mobile
                                :showPlaceholder="false"
                                placeholder="Nhóm danh mục"
                                title="Nhóm danh mục"
                                v-model="cat_parent"
                                class="select-mobile-post"
                                v-else>
                                <ldc-option-mobile
                                    v-for="(index, key) in arrGroup" :key="key"
                                    :value="index.ucg_id"
                                    :label="index.ucg_name"/>
                            </ldc-select-mobile>
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-flex mt-3 border-top border-bottom pt-1 pb-1" v-if="show_cat">
                <i class="ion-ios-undo undo-icon" v-if="parent_id != 0 && $detect == 'mobile'" @click="undo"></i>
                <h5 :class="{
                    'title-cat': true,
                    'm-0-auto' : $detect == 'mobile'
                    }">Chọn danh mục của bạn</h5> <i class="ion-ios-undo undo-icon ml-2" v-if="parent_id != 0 && $detect == 'web'" @click="undo"></i>
            </div>
            <div v-if="arrCategory.length == 0" style="height: 250px;"> </div>
            <div class="" v-if="show_cat">
               <div :class="{
                    'n-cat' : true,
                    'border-bottom pt-1 pb-1' : $detect == 'mobile'
                }" v-for="(item, key) in arrCategory" :key="key">
                    <div v-if="item.has_child == 1" @click="GetCat(item)">
                        {{item.name}}
                    </div>
                    <div v-else >
                        <div v-if="arrActiveCat[item.id]">
                            {{item.name}} 
                            <span>
                                <b class="incate"><a :href="'/home/type.php?module=product&iCat='+item.id" title="">Xem</a> (Đã có trong danh mục sản phẩm)</b>
                            </span>
                        </div>
                        <div  @click="addCat(item)" v-else>
                            {{item.name}} 
                            <span>
                                <i class="ion-ios-add-circle add-icon"></i>
                            </span>
                        </div>
                    </div>
               </div>
            </div>
        </div>
        <div class="footer-modal text-center" v-if="action != 'add'">
            <button :class="{
                    'btn btn-confirm my-10px mr-10px': true,
                    'btn-sm': $detect == 'web'
                }"
                :disabled="loading"
                @click="submit()"
                >Xác nhận</button>
            <button :class="{
                    'btn btn-danger my-10px mr-10px': true,
                    'btn-sm': $detect == 'web'
                }"
                v-if="checkDataLink"
                @click="del()"
                >Hủy cài đặt</button>
        </div>
    </ldc-dialog>
</template>
<script>
export default {
    props: ['visible', 'data', 'action', 'multiple', 'dataMultiple', 'arrGroup'],
    data() {
        return {
            dialog: false,
            title: '',
            oneManipulation: {},
            colorTitle: '',
            amount: '',
            actionMuti: false,
            total: 0,
            loading: false,
            source_pay: this.$detect == 'web' ? 0: 1,
            max_amount : 0,
            checkDataLink : false,

            arrEdit : [],
            uc_cat_name_alias : '',
            uc_group_id: 0,
            checkedNames : [],
            files : [],
            fileUploaded: [],
            uc_order : 0,
            uc_homepage : 0,
            uc_homepage_icon : 0,
            uc_show_child : 0,
            uc_hide  : 0,
            picture : '',
            cat_parent : 0,
            parent_id: 0,
            arrCategory : [],
            show_cat : false,
            arrActiveCat : [],
        }
    },
    watch: {
        cat_parent(val){
            this.getCategory();
            this.show_cat = true;
        },
        visible(val){
            this.dialog = val;
            
        },
        dialog(val){
            this.$emit('update:visible', val);
            
        },
        action(val){
            if(val == 'add'){
                this.title = 'Thêm mới danh mục';
                this.colorTitle = '#dc3545';
                this.getListCategory();
            }else if(val == 'edit'){
                this.title = 'Sửa danh mục';
                this.oneManipulation = this.config.con_raovat_super_vip_price;
                this.colorTitle = '#20c997';
            }else if(val == 'auto'){
                this.title = 'Up tự động';
                this.oneManipulation = this.config.con_raovat_up_price;
                this.colorTitle = '#0c81f6';
            }
        },
        data(){
            if(this.action == 'edit'){
                this.checkedNames = [];
                this.getDataCategoryUser();
            }
        },
        checkedNames(val){
            this.uc_homepage_icon = 0;
            this.uc_homepage = 0;
            this.uc_show_child = 0;
            this.uc_hide = 0;
            val.map(item => {
                if(item == 'homepage_icon'){
                    this.uc_homepage_icon = 1;
                }
                if(item == 'homepage'){
                    this.uc_homepage = 1
                }
                if(item == 'show_child'){
                    this.uc_show_child = 1
                }
                if(item == 'hide'){
                    this.uc_hide = 1
                }
            });
        },
        amount(newVal, oldVal) {
            if(newVal * 1 == newVal && newVal % 1 == 0){
                if(newVal <= 1000){
                    if(this.actionMuti){

                    }else{
                        this.singleAction();
                    }
                }else{
                    this.amount = 1000;
                }
            }else{
                this.amount = oldVal;
            }
        }
    },
    created (){

    },
    mounted(){

    },
    computed: {
        config(){
            return this.$store.state.config;
        },
        money(){
            return this.$store.state.money;
        },
    },
    methods: {
        undo(){
            this.parent_id = 0;
            this.getCategory();
        },
        GetCat(val){
            this.parent_id = val.id;
            this.getCategory();
        },
        async addCat(val){    
            await apiPost('v2/profile/products/add_user_category', {
                uc_category_id: val.id,
                uc_group_id: this.cat_parent,
            }).then(res => {
                this.$message({
                        message: res.message,
                        type: 'success',
                        center: true,
                    });
                this.dialog = false;
                this.loading = false;
            }).catch(err => {
                if(err.status == 410){
                    this.$message({
                        message: err.data.message,
                        type: 'error',
                        center: true,
                    });
                    
                 }
            })
        },
        getCategory(){
            apiGet('v2/category', {
                module: 'product',
                parent_id: this.parent_id,
            }).then(res => {
                this.arrCategory = res
            }).catch(err => {
                if(err.status == 410){
                    this.$message({
                        message: err.data.message,
                        type: 'error',
                        center: true,
                    });
                    
                 }
            })
        },
        upload(){
            let input = this.$el.querySelector('.input-upload');
            input.click();
        },
        async changeImage(e){
            let files = e.target.files;
            for(let item of files){
                item.url = URL.createObjectURL(item);
                item.show = true;
                this.files.unshift(item);
            }
            if(files.length == 0) this.loading = false;
            await this.uploadCdn();
        },
        async uploadCdn(){
            let form;
            for(let item of this.files.reverse()){
                if(item.type == 'image/jpeg' || item.type == 'image/png' || item.type == 'image/jpg'){
                    if(item.size > 120*120){
                        this.$message({
                            type: 'error',
                            message: 'Dung lượng file lớn hơn giới hạn cho phép',
                            center: true,
                        });
                        this.loading = true;
                    }else{
                        form = new FormData();
                        form.append('files', item);
                        await apiPost(`https://cdnvg.scandict.com/upload.php`, form).then(async res => {
                            let data = res[0];
                            if(data.success == 1){
                                this.fileUploaded.unshift(data);
                                this.picture = data.url;
                            }else{
                                this.$message({
                                    message: `Upload ảnh ${item.name} bị lỗi`,
                                    type: 'error',
                                    center: true,
                                });
                            }
                        }).catch(err => {
                            this.$message({
                                type: 'error',
                                message: 'Lỗi hệ thống',
                                center: true,
                            });
                        });
                        this.loading = false;

                    }
                }else{
                    this.$message({
                        type: 'error',
                        message: 'Phần mở rộng của file không đúng, bạn chỉ upload được những file có phần mở rộng là: jpg, jpeg, png',
                        center: true,
                    });
                        this.loading = true;

                }
            }
            this.files = [];
        },
        del(){apiPost('/v2/products/add_happy_link', {
                iPro: this.data.id,
                action     : 'delete'
            }).then(res => {
                console.log(res)
                this.$message({
                    message: res.message,
                    type: 'success',
                    center: true,
                });
                this.visible = false;
                this.loading = false;
            }).catch(err => {
                if(err.status == 410){
                    this.$message({
                        message: err.data.message,
                        type: 'error',
                        center: true,
                    });
                    
                 }
            })
        },
        maxAmount(){
            this.max_amount = this.$formatNumber(this.max_amount)
        },
        getListCategory(){
            apiGet('v2/profile/products/get_list_user_category').then(res => {
               this.arrActiveCat  = res.data;

            }).catch(err => {
                if(err.status == 410){
                    this.$message({
                        message: err.data.message,
                        type: 'error',
                        center: true,
                    });
                    
                 }
            })
        },
        getDataCategoryUser(){
            apiGet('v2/profile/products/get_data_user_category', {
                id: this.data.iCat,
            }).then(res => {
                this.arrEdit = res.data;
                this.uc_cat_name_alias = this.data.cat_name_alias
                this.uc_group_id = res.data.uc_group_id;
                this.picture = res.data.uc_icon;
                console.log(res)

                for (const [key, value] of Object.entries(res)) {
                    if(value.uc_homepage_icon == 1){
                        this.checkedNames.push('homepage_icon')
                        this.uc_homepage_icon = value.uc_homepage_icon;
                    }
                    if(value.uc_hide == 1){
                        this.checkedNames.push('hide')
                        this.uc_hide = value.uc_hide;
                    }
                    if(value.uc_homepage == 1){
                        this.checkedNames.push('homepage')
                        this.uc_homepage = value.uc_homepage;
                    }
                    if(value.uc_show_child == 1){
                        this.checkedNames.push('show_child')
                        this.uc_show_child = value.uc_show_child;
                    }
                }

            }).catch(err => {
                if(err.status == 410){
                    this.$message({
                        message: err.data.message,
                        type: 'error',
                        center: true,
                    });
                    
                 }
            })
        },
        singleAction(){
            if(!this.multiple){
                this.total = this.amount * this.oneManipulation.money;
            }else{
                this.total = this.amount * this.oneManipulation.money * this.dataMultiple.length;
            }
        },
        submit(){
            // if(!this.multiple){
                if(this.action == 'edit'){
                    this.edit();
                }
          
        },
        async edit(){
            this.loading = true;
            let idReturn = null;
            await apiPut('/v2/products/edit_user_category', {
                uc_category_id  : this.data.iCat,
                uc_group_id : this.uc_group_id,
                uc_cat_name_alias   : this.uc_cat_name_alias,
                uc_order    : this.uc_order,
                uc_homepage :  this.uc_homepage,
                uc_homepage_icon    : this.uc_homepage_icon,
                uc_show_child   : this.uc_show_child,
                uc_hide : this.uc_hide,
                files : this.fileUploaded,
                record_id : this.data.iCat,
            }).then(res => {
                this.$message({
                    message: res.message,
                    type: 'success',
                    center: true,
                });
                this.dialog = false;
                this.loading = false;
            }).catch(err => {
                if(err.status == 410){
                    this.$message({
                        message: err.data.message,
                        type: 'error',
                        center: true,
                    });
                    
                 }
            })
        },
    }
}
</script>
<style lang="scss">
.m-0-auto{
    margin: 0 auto;
}
.n-cat{
    padding-top: 10px;
}
.bor-top{
    border-top: 1px solid #e5e5e5;
}
.select-mobile-post{
    border: 1px solid #e5e5e5;
    border-radius: 4px;
    .ion-md-arrow-dropdown{
        float: right;
    }
}
.modal-mobile-vip{
    &.modal-HappyLink{
        .title-dialog{
            background : #dc3545;
        }
    }
    &.modal-dght{
        .title-dialog{
            background : #20c997;
        }
    }
}
.title-cat{
    margin-bottom: 0;
    color: #007bff;
}
.undo-icon{
    font-size: 19px;
    color: #007bff;

}
.add-icon{
    color : #20c997;
}
.image-icon{
    width : 42px;
    height : 42px;
}
.incate{
    font-size : 11px;
    color: #dc3545;
}
.w-100px{
    width : 100px;
}
.w-155{
    width : 155px !important;
}
.modal-mobile-vip{
    .content-modal{
        margin-top : 0;
    }
    &.modal-HappyLink {
        .footer-modal{
            .btn-confirm, .btn-danger{
                width: 40%;
            }
        }
    }
}
    .modal-register-vip, .modal-mobile-vip{
        &.modal-HappyLink{
            .title-dialog {
                border-bottom: 1px solid #dc3545;
            }
            .footer-modal{
                border-top: 1px solid #dc3545;
                .btn-confirm{
                    color: white;
                    background : #dc3545;
                }
            }
        }
        &.modal-dght {
            .title-dialog {
                border-bottom: 1px solid #20c997;
            }
            .footer-modal{
                border-top: 1px solid #20c997;
                .btn-confirm{
                    color: white;
                    background : #20c997;
                }
            }
        }
    }
    .product-dialog{
        .content-change-time{
            .date-change{
                height: 35px;
                border-radius: 4px;
                border: 1px solid rgba(0, 0, 0, 0.2);
                color: #606266;
                outline: none;
                cursor: pointer;
            }
        }

        .content-modal{
            .value{
                .select-dght{
                    height: 35px;
                    border-radius: 4px;
                    border: 1px solid rgba(0, 0, 0, 0.2);
                    color: #606266;
                    outline: none;
                    cursor: pointer;
                    width: 155px;
                }
                .input-link{
                    width: 95.5%;
                }
                .border-none{
                    border : unset;
                }
                .input-price-vip{
                    width: 155px;
                    color : #dc3545;
                }
                .span-happy-link{
                    border: unset;
                }
            } 
        }
    }
    .m_input{
        -webkit-appearance: none;
        background-color: #fff;
        background-image: none;
        border-radius: 4px;
        border: 1px solid #dcdfe6;
        box-sizing: border-box;
        color: #606266;
        display: inline-block;
        height: 40px;
        line-height: 40px;
        outline: none;
        padding: 0 15px;
        width : 100%;
    }
</style>
